import React, { useContext, useEffect, useState } from "react";

import { Redirect, RouteComponentProps } from "react-router";
import { IonContent, IonPage, IonToast } from "@ionic/react";

import { Auth, useAuth } from "../services/AuthService";
import { useLogger } from "../services/LogService";
import { AppContext } from "../state/AppContextProvider";
import { ActionType } from "../state/GlobalState";
import { LogoHeader } from "../components/landing/LogoHeader";

interface LoginRedirectPageProps extends RouteComponentProps { }

const LoginRedirect: React.FC<LoginRedirectPageProps> = ({
  location,
  history,
}) => {
  const { state, dispatch } = useContext(AppContext);

  const [loginUrl, setLoginUrl] = useState("");

  const console = useLogger("LoginRedirect");

  const auth = useAuth();

  useEffect(() => {
    const url = auth.authConfig.redirect_url + location.search;
    console.info("useEffect() url=" + url, location);

    const isCap = Auth.isApp();
    const isFromApp = Auth.isFromApp();

    if (!isFromApp || (isCap && isFromApp)) {
      // universal links opened or web context
      if (state.isAuthLoaded) {
        console.info(
          "useEffect() isAuthLoaded=true, isConnected=" + state.isConnected
        );
        if (state.isConnected) {
          // disconnect
          dispatch({
            type: ActionType.Disconnect,
            payload: false,
          });
        }
        auth.authorizationCallback(url);
        setTimeout(() => {
          if (history.location.pathname.startsWith('/loginredirect')) {
            history.replace("/landing");
          }
        }, 3000);
      }
    } else {
      // universal links not opened
      setLoginUrl(Auth.getWebBaseUrl() + Auth.LOGIN_PATH + location.search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, state.isAuthLoaded]);

  if(state.isConnected) {
    console.info(`LoginRedirect requested path:`, state.requestedPath);
  }

  return state.isConnected ? (
    <Redirect to={state.requestedPath} />
  ) : (
    <IonPage>
      <div className="w-full h-full items-center">
        <LogoHeader />
        <IonContent>
          {loginUrl !== "" && <EnterButton to={loginUrl} />}
          <IonToast
            isOpen={loginUrl === ""}
            color="dark"
            position="top"
            message="Chargement / Loading..."
            duration={2500}
          />
        </IonContent>
      </div>
    </IonPage>
  );
};

export default LoginRedirect;

const EnterButton = ({ to }) => (
  <div className="grid grid-flow-row gap-y-5 md:gap-y-10 py-5 md:py-10 text-center justify-center bg-white h-4/5 xl:h-3/5 px-6">
    <div className="flex flex-col-reverse justify-center">
      <div>
        <h2 className="text-xl font-bold mb-2 leading-6">
          Bienvenue sur le Portail des résidents CiuP
        </h2>
        <p className="text-sm text-gray-500">
          Entrez dans l'application pour accéder à de nombreux services et
          profiter de la vie du campus.
        </p>
      </div>
    </div>
    <div className="flex flex-col-reverse justify-center">
      <div>
        <h2 className="text-xl font-bold leading-6 italic text-primary">
          Welcome to the CiuP residents Portal
        </h2>
        <p className="text-sm text-primary text-opacity-80 italic">
          Enter into the app to access many services and enjoy campus life.
        </p>
      </div>
    </div>
    <div className="place-self-center grid grid-rows-2">
      <div className="grid items-center">
        <a
          href={to}
          className="inline-flex items-center justify-center px-6 py-4 w-full border border-transparent shadow-sm font-bold rounded-3xl text-sm text-white text-center bg-primary  hover:bg-primary hover:bg-opacity-75 focus:outline-none "
        >
          Enter / Entrez
        </a>
      </div>
    </div>
  </div>
);
